import Interval from './Interval.vue';
export default Interval;
